export function defaultOnInputChange() {
    const fieldset = this.closest("fieldset");

    this.setAttribute("value", this.value);

    if (!fieldset) return;

    const legend = fieldset.querySelector("legend");

    if (!legend) return;

    if (this.value.trim().length <= 0) {
        legend.style.translate = "0 -70%";
        legend.style.fontSize = "12px";
    } else {
        legend.style.removeProperty("translate");
        legend.style.removeProperty("font-size");
    }
}

export function setDefaultInputListeners() {
    const inputs = document.querySelectorAll("input, textarea");

    inputs.forEach((inputElem) => {
        inputElem.setAttribute("value", inputElem.value);
        inputElem.addEventListener("input", defaultOnInputChange);
    });
}
